/**
 * Cross-program team search, used only when setting up a new game.
 *
 * This deliberately bypasses ../utils/storage.ts and ../offline/sync.ts: those exist
 * to mirror *your own* data for offline use, and "every other program's discoverable
 * teams" isn't something that can be meaningfully mirrored — this is a live,
 * online-only lookup, hit directly through the API client.
 */

import { api, seg } from './client';

/**
 * One search hit. Display data only — name and player display names, nothing about
 * that program's games, stats, or membership. `accountId`/`teamId` let the caller tag
 * a game with where a selected team came from, an identity snapshot rather than a
 * live reference (see `Game.team1SourceAccountId` etc. in types/curling.ts).
 */
export interface SavedTeamSearchResult {
  accountId: string;
  teamId: string;
  programName: string;
  name: string;
  playerNames: string[];
}

/** Resolves to `[]` for a query under two characters, matching the server's own floor. */
export const searchSavedTeams = (query: string): Promise<SavedTeamSearchResult[]> =>
  query.trim().length < 2
    ? Promise.resolve([])
    : api.get<SavedTeamSearchResult[]>(`/saved-teams/search?q=${seg(query.trim())}`);
